import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=ebd1865a&scoped=true&"
import script from "./TabGeneral.vue?vue&type=script&lang=ts&"
export * from "./TabGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./TabGeneral.vue?vue&type=style&index=0&id=ebd1865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd1865a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ebd1865a', component.options)
    } else {
      api.reload('ebd1865a', component.options)
    }
    module.hot.accept("./TabGeneral.vue?vue&type=template&id=ebd1865a&scoped=true&", function () {
      api.rerender('ebd1865a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasComerciales/tabs/TabGeneral.vue"
export default component.exports